/**
 * The iOS Control Center "turn on Bluetooth" screenshot, with an inline SVG
 * fallback (a stylised Control Center toggle) so it's never blank if the asset
 * is missing. Shared by the Bluetooth-off notice and the reconnect checklist.
 */
import { useState } from 'react';

import Box from '@mui/material/Box';

import turnOnBluetoothImg from 'src/assets/images/turn-on-bluetooth-controlcenter.png';

// ----------------------------------------------------------------------

/** Stylised Control Center connectivity module with Bluetooth highlighted. */
function ControlCenterBluetoothMock() {
  return (
    <Box
      component="svg"
      viewBox="0 0 160 160"
      role="img"
      aria-label="Bluetooth toggle in Control Center"
      sx={{ width: '100%', maxWidth: 200 }}
    >
      <rect x="4" y="4" width="152" height="152" rx="28" fill="#1c1c1e" />
      {/* Airplane / cellular (inactive-ish) */}
      <circle cx="52" cy="52" r="22" fill="#3a3a3c" />
      <circle cx="108" cy="52" r="22" fill="#34c759" />
      {/* Wi-Fi */}
      <circle cx="52" cy="108" r="22" fill="#0a84ff" />
      {/* Bluetooth — highlighted */}
      <circle cx="108" cy="108" r="22" fill="#0a84ff" />
      <circle cx="108" cy="108" r="27" fill="none" stroke="#ff3b30" strokeWidth="4" />
      <path
        d="M108 95 L116 102 L104 112 L116 121 L108 128 L108 95 M104 102 L100 99 M104 121 L100 124"
        fill="none"
        stroke="#fff"
        strokeWidth="3.2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </Box>
  );
}

interface BluetoothControlCenterImageProps {
  maxWidth?: number;
}

export default function BluetoothControlCenterImage({
  maxWidth = 280,
}: BluetoothControlCenterImageProps) {
  const [imgFailed, setImgFailed] = useState(false);

  if (imgFailed) return <ControlCenterBluetoothMock />;

  return (
    <Box
      component="img"
      src={turnOnBluetoothImg}
      alt="Turn on Bluetooth in Control Center"
      onError={() => setImgFailed(true)}
      sx={{ width: '100%', maxWidth, borderRadius: 2, boxShadow: 3 }}
    />
  );
}
